/* eslint-disable import/prefer-default-export */
import { isNull, reduce } from 'lodash';

import graphqlClient from '../graphql';
import {
  getOriginalOrderPayloadGql,
  getRequestByReferenceIdGql,
  listPomRequestsStatusGql,
  resendPartnerWebhookGql,
} from './gql';
import { transformListPomRequestsStatus, transformPomRequestDetails } from './transform';

export const listPomRequestsStatusApi = ({ page, sortBy, filter }) =>
  graphqlClient
    .request(listPomRequestsStatusGql, {
      offset: (page - 1) * 25,
      sortBy,
      filter: reduce(
        filter,
        (result, value, key) => ({
          ...result,
          [key]: isNull(value) ? undefined : value,
        }),
        {}
      ),
    })
    .then(transformListPomRequestsStatus);

export const getRequestByReferenceIdApi = ({ referenceId, requestId, orderId, partnerId }) =>
  graphqlClient
    .request(getRequestByReferenceIdGql, { referenceId, requestId, orderId, partnerId })
    .then(transformPomRequestDetails);

export const getOriginalOrderPayloadApi = ({ originalRequestId }) =>
  graphqlClient
    .request(getOriginalOrderPayloadGql, { originalRequestId })
    .then(({ getOriginalOrderPayload }) => getOriginalOrderPayload);

export const resendPartnerWebhookApi = ({ eventRegistryPkId }) =>
  graphqlClient
    .request(resendPartnerWebhookGql, { eventRegistryPkId })
    .then(({ resendPartnerWebhook }) => resendPartnerWebhook);
